import { useState, useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { TABLE_VIEW } from './project-summary-helper';

// Convert filterCriteria to GraphQL filter format
const buildFilterArray = (filters) => {
  const filterArray = [];

  if (filters.projectName && filters.projectName.trim()) {
    filterArray.push({
      searchBy: 'PROJECT_NAME',
      search: filters.projectName.trim()
    });
  }

  if (filters.projectNumber && filters.projectNumber.trim()) {
    filterArray.push({
      searchBy: 'PROJECT_ID',
      search: filters.projectNumber.trim()
    });
  }

  if (filters.projectStatus && filters.projectStatus.trim()) {
    filterArray.push({
      searchBy: 'STATUS',
      search: filters.projectStatus.trim()
    });
  }

  return filterArray;
};

export const useProjects = ({
  page, pageSize = 10, view = TABLE_VIEW, isValidCustomer, sortCriteria, filterCriteria = {}
}) => {
  // @TODO remove page number state (solve delete scenario when user already navigated multiple pages)
  const { svocID } = useThdCustomer();

  const [pageNumbers, setPageNumber] = useState([]);

  const {
    data, error, loading, refetch, client
  } = useDataModel('projects', {
    variables: {
      page: page || 1,
      pageSize,
      accountId: svocID,
      filter: buildFilterArray(filterCriteria),
      sort: sortCriteria,
      skipNumberOfItems: view === TABLE_VIEW,
      skipImages: view === TABLE_VIEW,
    },
    ssr: false,
    skip: (!svocID) || !isValidCustomer,
    context: { withAuth: true }
  });

  useEffect(() => {
    if (!pageNumbers.includes(page)) {
      setPageNumber([...pageNumbers, page]);
    }
  }, [page]);

  const { projects: projectsResponse } = data || {};

  let projects = projectsResponse?.projects ? projectsResponse?.projects : [];

  const refetchProjects = async ({ page: pageNo }) => {
    const loadedPages = pageNumbers.filter((pg) => pg >= pageNo && pg !== page);
    const clearPromises = loadedPages.map((pgNo) => {
      return client.cache.evict({
        id: 'ROOT_QUERY',
        fieldName: 'projects',
        args: { page: pgNo, pageSize }
      });
    });
    await Promise.all(clearPromises);
    await client.cache.gc();
    refetch({ page });
  };

  return {
    pagination: {
      pageSize: projectsResponse?.pageSize,
      totalResults: projectsResponse?.totalProjects,
      totalPages: Math.ceil((projectsResponse?.totalProjects || 0) / pageSize),
      hasMore: projectsResponse?.totalProjects > pageSize * projectsResponse?.page
    },
    projects,
    error,
    loading: loading || typeof data === 'undefined',
    refetchProjects
  };
};
